var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "share") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHARE",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.78468207 2.55603976 2.84217094e-14 2.55603976 2.84217094e-14 12.5409844 12.6654361 12.5409844 12.6654361 9.94448327 11.3735925 9.94448327 11.3735925 11.2834003 1.39783402 11.2834003 1.39783402 3.82428603 3.78468207 3.82428603"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "3.85983888 8.80377244 3.85983888 6.20768136 5.07969167 6.20768136 5.07969167 5.0181708 6.33271807 5.0181708 6.33271807 3.81991182 7.62566292 3.81991182 7.62566292 2.55603976 10.2176092 2.55603976 10.2176092 5.63547113e-14 11.4049766 5.68434189e-14 11.4049766 1.27275717 12.6654361 1.27275717 12.6654361 2.55603976 13.8208688 2.55603976 13.8208688 3.81991182 15.1234491 3.81991182 15.1234491 5.0181708 13.8208688 5.0181708 13.8208688 6.20768136 12.6654361 6.20768136 12.6654361 7.5485121 11.4049766 7.5485121 11.4049766 8.80377244 10.2176092 8.80377244 10.2176092 6.20768136 7.62566292 6.20768136 7.62566292 7.5485121 5.07969167 7.5485121 5.07969167 8.80377244"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fd321587a320ca5d51c82e31f090148a.svg";
export { ForwardRef as ReactComponent };